/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Card, Image } from 'react-bootstrap';

export interface ICardWidgetProps {
  title?: string;
  value?: string;
  period?: string;
  country?: string;
  icon?: string | any;
}

const isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};

export const CardWidget = ({
  title,
  value,
  period,
  country,
  icon,
}: ICardWidgetProps) => {
  const _getIcon = (Icon: any) => {
    let _icon: any = [];
    if (typeof Icon === 'string') {
      if (isValidUrl(Icon)) {
        _icon.push(
          <Image
            key={`image-icon`}
            src={Icon}
            width={60}
            height={60}
            className="icon icon-xxs text-gray-500 me-1"
          />
        );
      } else {
        const HeroIcon = require('@heroicons/react/solid');
        const NavIcon = HeroIcon[Icon];
        if (NavIcon) {
          _icon.push(
            <NavIcon
              key={`hero-icon`}
              src={Icon}
              className="icon icon-xxs text-gray-500 me-1"
            />
          );
        }
      }
      return _icon;
    }
    if (Icon) {
      _icon.push(
        <Icon
          key={`hero-icon-2`}
          className="icon icon-xxs text-gray-500 me-1"
        />
      );
    }
    return _icon;
  };
  const _renderTitleIf = () => {
    if (title) {
      return <h2 className="fs-5 fw-normal">{title}</h2>;
    }
  };
  const _renderValueIf = () => {
    if (value) {
      return <h3 className="fs-2 fw-extrabold mb-1">{value}</h3>;
    }
  };
  const _renderPeriodIf = () => {
    if (period) {
      return (
        <div className="d-flex align-items-center">
          <span className="me-3">{period}</span>
          {icon && _getIcon(icon)}
          {country && <span>{country}</span>}
        </div>
      );
    }
  };
  return (
    <>
      {title && (
        <Card border="0" className="shadow">
          <Card.Body>
            {_renderTitleIf()}
            {_renderValueIf()}
            {_renderPeriodIf()}
          </Card.Body>
        </Card>
      )}
    </>
  );
};

CardWidget.defaultProps = {};
